import axios from "axios";
import { showErrorSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper";
import Utils from "@/scripts/Utils";
export var HOST =Utils.getEnv() == 'local' ? 'http://localhost:3000/api/pdf/v1/' : "https://pdf-generator-cu622gxaua-uc.a.run.app/api/pdf/v1/"

const apiService = axios.create({
    baseURL: HOST,
    timeout: 5 * 60000,
});
apiService.defaults.headers.common['Authorization'] = process.env.VUE_APP_API_AUTHORIZATION;

apiService.interceptors.request.use(async function (config) {
    if (config.method && config.method === "post") await apiService.options()
    return config;
}, function (error) {
    return Promise.reject(error);
});

apiService.interceptors.response.use((response) => response, (error) => {
    console.error("Response error", error);
    if (!error.response || error.response.status == 500)
        showErrorSnackBar("Ocorreu um erro não identificado, entre em contato com nossa equipe de suporte.")
    else
        showInfoSnackBar(error.response.data.message)
    throw error;
});

export const showPdfNewTab = async (signedUrl) => {


    // const response = await fetch(signedUrl);
    // const blob = await response.blob();
    // saveAs(blob,"PDF FOZ"); // Nome do arquivo

    const pdfWindow = window.open("", "_blank");
    pdfWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title> Foz Sustentável </title>
        </head>
        <body style="margin: 0; padding: 0;">
            <iframe src="${signedUrl}" width="100%"  style="border: none; height: calc(100vh - 5px)"></iframe>
        </body>
        </html>
    `);
}
// export const showPdfNewTab = async (signedUrl) => {

//     const response = await fetch(signedUrl);
//     if (!response.ok) throw new Error("Erro ao baixar o PDF");

//     // Cria um blob com o conteúdo do PDF
//     const blob = await response.blob();
//     const url = URL.createObjectURL(blob);

//     // Cria um link temporário para download
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "Foz PDF.pdf"; // Nome do arquivo baixado
//     a.click();

//     // Libera o objeto URL para liberar memória
//     URL.revokeObjectURL(url);
// }



export default apiService